import { assert } from '@disy/lib/custom-error';

import type { DataSourceFlavor } from 'cadenza/repository/data-source-flavor';
import type { DataSourceType } from 'cadenza/repository/model/data-source-type.gen';
import { needsFlavor } from 'cadenza/repository/model/data-source-type-util';

import i18n from './db-flavor-or-datasource-type-utils.properties';

/**
 * Utils to name datasource specifics (dbFlavor or ,if not available, type).
 * A flavor is available only for certain datasource types, so it is returned only in such cases.
 * Otherwise, the datasource type is returned;
 *
 * @param type - {DataSourceType}- datasource type
 * @param flavor - {DataSourceFlavor} - flavour (applies for certain datasource types)
 * @return the text representing the flavor/type details
 */
export function getDataSourceFlavorOrDataSourceTypeAsText(type: DataSourceType, flavor?: DataSourceFlavor) {
  assert(!needsFlavor(type) || flavor, `Datasource type \`${type}\` needs to have a flavor provided`);
  return i18n(`datasource-type.<${flavor?.toLocaleLowerCase() || type?.toLocaleLowerCase()}>.printName`);
}

/**
 * Less strict, thus also less preferred version of `getDataSourceFlavorOrDataSourceTypeAsText`. Helpful
 * if you need to handle unexpected datasources.
 *
 * @param type - {DataSourceType}- datasource type
 * @param flavor - {DataSourceFlavor} - flavour (applies for certain datasource types)
 * @return the text representing the flavor/type details
 */
export function getDataSourceFlavorOrDataSourceTypeOrUnknownAsText(type?: DataSourceType, flavor?: DataSourceFlavor) {
  if (!type || (!needsFlavor(type) && !flavor)) {
    return i18n('datasource-type.unknown.printName');
  }
  return getDataSourceFlavorOrDataSourceTypeAsText(type, flavor);
}
